import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'sanitizeHtml',
    standalone: true,
})
export class HtmlSanitizerPipe implements PipeTransform {
    public constructor(private sanitizer: DomSanitizer) {}

    public transform(value: string): SafeHtml {
        if (!value) return '';
        // ✅ Sanitisation réelle : supprime les balises/attributs dangereux
        return this.sanitizer.sanitize(SecurityContext.HTML, value) ?? '';
    }
}
